import { render } from "./tabApprovedProcess.vue?vue&type=template&id=5906fcf2&scoped=true"
import script from "./tabApprovedProcess.vue?vue&type=script&lang=js"
export * from "./tabApprovedProcess.vue?vue&type=script&lang=js"

import "./tabApprovedProcess.vue?vue&type=style&index=0&id=5906fcf2&scoped=true&lang=css"

import exportComponent from "/Users/home/Documents/kevin/migration_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5906fcf2"]])

export default __exports__